import { useContext } from 'react';
import classnames from 'classnames';
import { QuestionsContext } from '../../context/Questions';
import './wizard-user.scss';

interface IWizard {
    questions: any;
    dataUser?: any;
}

const WizardUser = ({ questions, dataUser }: IWizard) => {
    const { selectedMenu } = useContext(QuestionsContext);

    const createDefaultSelect = (q: any) => {
        const { tipopregunta } = q || {};
        let temp = null;

        if (tipopregunta === 1) {
            temp = {
                label: q?.respuesta?.respuestatexto[0].respuestatexto || '',
                value: q?.respuesta?.respuestatexto[0].idpregunta || '',
            };
        } else if (tipopregunta === 2) {
            temp = (q?.respuesta?.respuestatexto || []).map((item: any) => ({
                label: item.respuestatexto || '',
                value: item.idpregunta || '',
            }));
        }

        return temp;
    };

    const donwloadAttach = (url: string | null) => {
        if (url) {
            const urlFile = url;
            const link = document.createElement('a');
            link.href = urlFile;
            link.target = '_blank';
            link.setAttribute(
                'download',
                `${url.split('/')[url.split('/').length - 1]}`
            );
            document.body.appendChild(link);
            link.click();
            link?.parentNode?.removeChild(link);
        }
    };

    const getShortUrl = (url: string = '') => {
        return url.split('/')[url.split('/').length - 1];
    };

    return (
        <>
            {questions.map((q: any) => (
                <div key={'idC' + q?.idcategoria}>
                    {q?.secciones?.length > 0 &&
                        q?.secciones.map((s: any) => (
                            <div
                                key={
                                    'idS' + s?.idseccion + '-' + q?.idcategoria
                                }
                                className={classnames({
                                    WizardSection: true,
                                    Hide:
                                        selectedMenu?.value?.toString() !==
                                        q?.idcategoria?.toString(),
                                })}
                            >
                                <h5 className="WizardTitle">
                                    {s?.descripcion}
                                </h5>
                                {s?.preguntas?.length > 0 &&
                                    s?.preguntas.map((qI: any) => (
                                        <div
                                            className="mb1"
                                            key={
                                                'idQI' +
                                                q?.idcategoria +
                                                '-' +
                                                s?.idseccion +
                                                '-' +
                                                qI?.idpregunta
                                            }
                                        >
                                            {qI?.tipopregunta === 0 ||
                                            qI?.tipopregunta === 5 ? (
                                                // Input = 0, TextArea = 5
                                                <>
                                                    <label className="label">
                                                        {qI?.descripcion}
                                                    </label>
                                                    <div className="inputEmpty">
                                                        {qI?.respuesta?.respuestatexto.trim() ||
                                                            ''}
                                                    </div>
                                                </>
                                            ) : qI?.tipopregunta === 1 ||
                                              qI?.tipopregunta === 2 ? (
                                                // Select && Multiple
                                                <>
                                                    <label className="label">
                                                        {qI?.descripcion}
                                                    </label>
                                                    <div className="inputEmpty">
                                                        {qI?.tipopregunta ===
                                                            1 &&
                                                            createDefaultSelect(
                                                                qI
                                                            )?.label}
                                                        {qI?.tipopregunta ===
                                                            2 &&
                                                            createDefaultSelect(
                                                                qI
                                                            ).map(
                                                                (item: any) => (
                                                                    <span className="inputEmptySpan">
                                                                        {
                                                                            item?.label
                                                                        }
                                                                    </span>
                                                                )
                                                            )}
                                                    </div>
                                                </>
                                            ) : qI?.tipopregunta === 3 ? (
                                                // Video
                                                <div className="mb1">
                                                    <label className="label">
                                                        Video adjuntado
                                                    </label>

                                                    <div className="inputEmpty">
                                                        {dataUser?.urlvideo && (
                                                            <span
                                                                className="Link"
                                                                onClick={() =>
                                                                    donwloadAttach(
                                                                        dataUser.urlvideo
                                                                    )
                                                                }
                                                            >
                                                                {getShortUrl(
                                                                    dataUser.urlvideo
                                                                )}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            ) : qI?.tipopregunta === 4 ? (
                                                // Documento
                                                <div className="mb1">
                                                    <label className="label">
                                                        Declaración jurada
                                                        adjuntada
                                                    </label>
                                                    <div className="inputEmpty">
                                                        {dataUser?.urldeclaracionjurada && (
                                                            <span
                                                                className="Link"
                                                                onClick={() =>
                                                                    donwloadAttach(
                                                                        dataUser.urldeclaracionjurada
                                                                    )
                                                                }
                                                            >
                                                                {getShortUrl(
                                                                    dataUser.urldeclaracionjurada
                                                                )}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            ) : (
                                                ''
                                                // Tipo de pregunta diferente a: 0, 1, 2, 3, 4
                                            )}
                                        </div>
                                    ))}
                            </div>
                        ))}
                </div>
            ))}
        </>
    );
};

export default WizardUser;
